import type { Config } from '../../../../../shared/features/config';

type RecorderBitrateConfig = Pick<Config, 'recorderAudioBitsPerSecond' | 'recorderVideoBitsPerSecond'>;

export const getMediaRecorderInitOptions = (config: RecorderBitrateConfig): MediaRecorderOptions => {
    const options: MediaRecorderOptions = {};

    if (config.recorderAudioBitsPerSecond) {
        options.audioBitsPerSecond = config.recorderAudioBitsPerSecond;
    }

    if (config.recorderVideoBitsPerSecond) {
        options.videoBitsPerSecond = config.recorderVideoBitsPerSecond;
    }

    return options;
};
